import { RequestQueryBuilder, SConditionAND, SFields } from '@nestjsx/crud-request';
import { orderStatusList } from './processOrderStateCode';

// const defaultOrderState = [
//     '결제대기', '결제완료', '취소요청거절', '주문확인완료',
//     '배송대기', '배송중', '배송완료', '구매확정',
//     '구매취소', '주문취소', '취소요청',
//     '취소진행중', '반품요청', '교환진행중',
//     '반품요청승인', '반품진행중', '반품거절', '환불진행중',
//     '반품완료', '교환완료', '환불완료'
// ]

export const groupSalesQueryFilter = async (queryParams: any): Promise<string> => {
    const limit = queryParams?.limit || 15;
    const offset = queryParams?.offset || 0;
    const order_number = queryParams?.order_number || { like: '' };
    const orderer_name = queryParams?.orderer_name || { like: '' };
    const phone_number = queryParams?.phone_number || { like: '' };
    const ordered_at = queryParams?.ordered_at || { le: '', ge: '' };
    const order_state_type = queryParams?.order_state_type || { in: [] };
    const invoice_number = queryParams?.invoice_number || { eq: '' };
    const product_name = queryParams?.product_name || { like: '' };
    const qb = RequestQueryBuilder.create();
    const andFilter: (SConditionAND | SFields)[] = [];
    if (!!order_number?.like) andFilter.push({ orderNumber: order_number.like });
    else andFilter.push({ orderNumber: { $notnull: true } });
    if (!!orderer_name?.like) {
        andFilter.push({
            $or: [{ ordererName: { $contL: orderer_name.like } }, { recipientName: { $contL: orderer_name.like } }],
        });
    }
    if (!!phone_number.like) {
        andFilter.push({
            $or: [
                { ordererPhoneNumber: { $contL: phone_number.like } },
                { recipientPhoneNumber: { $contL: phone_number.like } },
            ],
        });
    }
    if (!!product_name?.like) {
        andFilter.push({
            'mallOrders.mallProduct.mallProductGroup.groupTitle': { $contL: product_name.like },
        });
    }
    if (!!ordered_at?.ge && !!ordered_at?.le) {
        andFilter.push({ $or: [{ orderedAt: { $between: [ordered_at.ge, ordered_at.le] } }] });
    }
    console.log('order_state_type::::', order_state_type);

    // orderStatus code를 한국어로 하드코딩 매핑 (언어 변경과 무관하게 API에는 한국어로 전달)
    const codeToKoreanMap: Record<string, string> = {
        'payment-wait': '결제대기',
        'payment-success': '결제완료',
        'order-reject': '주문취소',
        'payment-cancel-requested': '취소요청',
        'payment-cancel-confirmed': '취소승인',
        'payment-cancel-progressed': '취소진행중',
        'payment-cancel-completed': '구매취소',
        'confirmed-order': '주문확인완료',
        'return-requested': '반품요청',
        'return-confirmed': '반품승인',
        'return-progressed': '반품진행중',
        'refund-progressed': '환불진행중',
        'exchange-progressed': '교환진행중',
        'exchange-completed': '교환완료',
        'delivery-wait': '배송대기',
        'delivery-progressed': '배송중',
        'delivery-completed': '배송완료',
        'return-reject': '반품거절',
        'refund-completed': '환불완료',
        'trade-completed': '구매확정',
    };

    let statusLabel: string[] = [...order_state_type?.in]
        .map((status) => {
            return codeToKoreanMap[status] || '';
        })
        .filter((x) => x !== '');
    console.log('statusLabel::::', statusLabel);
    const checkConfirmed = statusLabel.includes('주문확인완료');
    if (checkConfirmed) {
        statusLabel.push('취소요청거절');
    }
    const checkIsShippingProgress = statusLabel.includes('배송중');
    if (checkIsShippingProgress) {
        statusLabel.push('배송대기');
    }
    if (statusLabel.length > 0) andFilter.push({ 'mallOrders.orderState': { $in: [...statusLabel] } });
    if (statusLabel.length === 0) {
        statusLabel = [
            '결제대기',
            '결제완료',
            '주문취소',
            '취소요청',
            '취소승인',
            '취소진행중',
            '구매취소',
            '주문확인완료',
            '반품요청',
            '반품승인',
            '반품진행중',
            '환불진행중',
            '교환진행중',
            '교환완료',
            '배송대기',
            '배송중',
            '배송완료',
            '반품거절',
            '환불완료',
            '구매확정',
        ];
        andFilter.push({ 'mallOrders.orderState': { $in: [...statusLabel] } });
    }
    if (!!queryParams?.invoice_number?.eq) {
        andFilter.push({ $or: [{ 'mallOrders.invoiceNumber': { $eq: invoice_number?.eq } }] });
    }
    qb.search({ $and: andFilter });
    const query = qb
        .setOffset(Number(offset))
        .setLimit(Number(limit))
        .sortBy({ field: 'orderedAt', order: 'DESC' })
        .query(false);
    return query;
};
